import * as firebase from "firebase";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDHS3YLmDMEMl1n-VqwOGzL18r9bj3FozI",
  authDomain: "ecommerce-16239.firebaseapp.com",
  databaseURL: "https://ecommerce-16239.firebaseio.com",
  projectId: "ecommerce-16239",
  storageBucket: "ecommerce-16239.appspot.com",
  messagingSenderId: "552684386940",
  appId: "1:552684386940:web:40be27b9d135262da127f9"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

// export
export const auth = firebase.auth();
export const googleAuthProvider = new firebase.auth.GoogleAuthProvider();
